<template>
  <span :class="badgeClasses">
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: 'BertBadge',
  props: {
    variant: {
      type: String,
      default: 'primary',
      validator: (value) => ['primary', 'secondary', 'accent', 'success', 'warning', 'error', 'neutral'].includes(value)
    },
    size: {
      type: String,
      default: 'md',
      validator: (value) => ['sm', 'md', 'lg'].includes(value)
    },
    outline: {
      type: Boolean,
      default: false
    },
    pill: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    badgeClasses() {
      return [
        'bert-badge',
        `bert-badge--${this.variant}`,
        `bert-badge--${this.size}`,
        {
          'bert-badge--outline': this.outline,
          'bert-badge--pill': this.pill
        }
      ]
    }
  }
}
</script>

<style scoped>
.bert-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-family-sans);
  font-weight: var(--font-medium);
  border-radius: var(--radius-base);
  white-space: nowrap;
}

/* Sizes */
.bert-badge--sm {
  padding: var(--space-1) var(--space-2);
  font-size: var(--text-xs);
}

.bert-badge--md {
  padding: var(--space-2) var(--space-3);
  font-size: var(--text-sm);
}

.bert-badge--lg {
  padding: var(--space-3) var(--space-4);
  font-size: var(--text-base);
}

/* Pill shape */
.bert-badge--pill {
  border-radius: var(--radius-full);
}

/* Variants - Filled */
.bert-badge--primary {
  background-color: var(--primary-600);
  color: white;
}

.bert-badge--secondary {
  background-color: var(--secondary-600);
  color: white;
}

.bert-badge--accent {
  background-color: var(--accent-600);
  color: white;
}

.bert-badge--success {
  background-color: var(--success-600);
  color: white;
}

.bert-badge--warning {
  background-color: var(--warning-600);
  color: white;
}

.bert-badge--error {
  background-color: var(--error-600);
  color: white;
}

.bert-badge--neutral {
  background-color: var(--neutral-600);
  color: white;
}

/* Variants - Outline */
.bert-badge--primary.bert-badge--outline {
  background-color: var(--primary-50);
  color: var(--primary-700);
  border: 1px solid var(--primary-200);
}

.bert-badge--secondary.bert-badge--outline {
  background-color: var(--secondary-50);
  color: var(--secondary-700);
  border: 1px solid var(--secondary-200);
}

.bert-badge--accent.bert-badge--outline {
  background-color: var(--accent-50);
  color: var(--accent-700);
  border: 1px solid var(--accent-200);
}

.bert-badge--success.bert-badge--outline {
  background-color: var(--success-50);
  color: var(--success-700);
  border: 1px solid var(--success-200);
}

.bert-badge--warning.bert-badge--outline {
  background-color: var(--warning-50);
  color: var(--warning-700);
  border: 1px solid var(--warning-200);
}

.bert-badge--error.bert-badge--outline {
  background-color: var(--error-50);
  color: var(--error-700);
  border: 1px solid var(--error-200);
}

.bert-badge--neutral.bert-badge--outline {
  background-color: var(--neutral-50);
  color: var(--neutral-700);
  border: 1px solid var(--neutral-200);
}
</style>